import { say } from "./say.ts";

export function oneDay(a: string, b: string): boolean {
  const one = new Date(a);
  const two = new Date(b);
  return (
    one.getFullYear() === two.getFullYear() &&
    one.getMonth() === two.getMonth() &&
    one.getDate() === two.getDate()
  );
}

export function daySaid(at: string): string {
  const now = new Date();
  const then = new Date(at);
  if (oneDay(at, now.toISOString())) return say("when.today");
  const yesterday = new Date(now.getTime() - 86400000);
  if (oneDay(at, yesterday.toISOString())) return say("when.yesterday");
  const sameYear = then.getFullYear() === now.getFullYear();
  return then.toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" }),
  });
}
